module.exports = __webpack_public_path__ + "static/img/A124.34d0e290.jpg";